import React from "react";
import { IWhitespaceMenuItem } from "interfaces/Components/WhitespaceMenu/IWhitespaceMenuItem";
import {  Navbar, Nav } from "react-bootstrap";
import { WhitespaceMenuEntry } from "./WhitespaceMenuEntry";

export interface IWhitespaceMenuProps {
    items : Array<IWhitespaceMenuItem>;
    logoutHandler: () => void;
    menuOpenHandler: (isMenuOpen : boolean) => void;
    isMenuOpen: boolean;
    showLogout: boolean;
    displayUsername: string;
    rootReturnUrl: string;
}

export const WhitespaceMenu  = ({items, logoutHandler, menuOpenHandler, isMenuOpen, showLogout, displayUsername, rootReturnUrl} : IWhitespaceMenuProps) => {

    const bannerMenuClosed = '.page {min-height: calc(100vh - 13.5em);} .banner {margin-top : 0.2em;} .banner .title{padding-left: 2em;}';

    function renderMenus() {
        return (items.map((menuItem, idx) => {
            return (<WhitespaceMenuEntry key={idx} whitespaceMenuItem={menuItem} rootReturnUrl={rootReturnUrl} isRootMenu={true} />);
        }));
    }

    return(
        <>
        {!isMenuOpen &&
            <style>
                {bannerMenuClosed}
            </style>
        }

        <button className={`whitespace-menu-burger ${isMenuOpen ? "d-none": "d-inline-block"}`} aria-controls="navbar" aria-label="Close menu" onClick={() => {menuOpenHandler(true)}}>
        <span className="menu-icon_box">
                            <span className="menu-icon_line menu-icon_line--1"></span>
                            <span className="menu-icon_line menu-icon_line--2"></span>
                            <span className="menu-icon_line menu-icon_line--3"></span>
                        </span>
        </button>

        <div className={`container-fluid bg-whitespace menu ${!isMenuOpen ? "d-none": ""}`}>

            <Navbar id="whitespace-menu" bg="whitespace" variant="dark" className="align-items-start w-100">
                <Navbar.Collapse id="navbar" className={`${isMenuOpen ? "d-flex" : "d-none"}`}>
                    <div className="d-sm-block d-xl-flex">
                    {renderMenus()}
                    </div>
                    <div className="container-fluid flex-nowrap menu-logout d-flex">
                        {showLogout && <Nav.Link className="btn btn-link btn-logout d-inline-flex" onClick={() => logoutHandler()}>LOGOUT {displayUsername}</Nav.Link>}
                        <button aria-label="Close menu" className="d-inline-flex navbtn" title="Close menu" onClick={() => {menuOpenHandler(false)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" focusable="false" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                            <path fillRule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                            </svg>
                        </button>  

                    </div>
                </Navbar.Collapse>
            </Navbar>
        </div>  
        </>
    )
};
